import request from '@/router/axios';

//查询离职交接数据列表
export function dataList(query) {
  return request({
    url: '/api/dimission/get/list',
    method: 'get',
    params: query
  })
}
//提交离职交接
export function lzComit(query) {
  return request({
    url: '/api/dimission/update',
    method: 'post',
    data: query
  })
}